// pages/ChangePassword.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
} from 'firebase/auth';
import styles from '../Styles/ChangePassword.module.css';

function ChangePassword() {
  const navigate = useNavigate();
  const user = auth.currentUser;
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [dots, setDots] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPwd !== confirmPwd) {
      setError('Uudet salasanat eivät täsmää.');
      return;
    }
    try {
      const cred = EmailAuthProvider.credential(user.email, oldPwd);
      await reauthenticateWithCredential(user, cred);
      await updatePassword(user, newPwd);
      setSuccess(true);
      setDots(0);
      let count = 0;
      const iv = setInterval(() => {
        count += 1;
        setDots(count);
        if (count >= 5) {
          clearInterval(iv);
          auth.signOut();
          navigate('/login');
        }
      }, 1500);
    } catch (err) {
      console.error(err);
      switch (err.code) {
        case 'auth/wrong-password':
          setError('Vanha salasana on väärin.');
          break;
        case 'auth/weak-password':
          setError('Uusi salasana on liian heikko (vähintään 6 merkkiä).');
          break;
        default:
          setError('Salasanan vaihto epäonnistui.');
      }
    }
  };

  return (
     <main className={styles.content}>
      <div className="login-container">
        {!success ? (
        <form onSubmit={handleSubmit}>
        <h1>Vaihda salasana</h1>
          <label>Vanha salasana</label>
          <input
            type="password"
            value={oldPwd}
            onChange={(e) => setOldPwd(e.target.value)}
            required
          />
          <label>Uusi salasana</label>
          <input
            type="password"
            value={newPwd}
            onChange={(e) => setNewPwd(e.target.value)}
            required
          />
          <label>Toista uusi salasana</label>
          <input
            type="password"
            value={confirmPwd}
            onChange={(e) => setConfirmPwd(e.target.value)}
            required
          />
         {error && <div className="login-error">{error}</div>}
          <div style={{ margin: '1rem 0' }}>
            <button type="submit">Vaihda salasana</button>
          </div>
           <span className={styles.resetLink} onClick={() => { navigate('/frontpage'); }}>
             &lt; Takaisin etusivulle
         </span>
        </form>
        ) : (
        <form>
           <h1>Salasana vaihdettu onnistuneesti!</h1>
          <div className="success">
            Odota hetki uudelleen ohjataan sinut sisäänkirjautumissivulle{'.'.repeat(dots)}
          </div>
        </form>
      )}
      </div>
    </main>
  );
}

export default ChangePassword;
